"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var routes_1 = require("../../../constants/routes");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@iconify/react");
var label_1 = require("../../../controls/label");
var constants_1 = require("../../../constants/constants");
var reset_password_1 = require("../../../api/calls/user/reset_password");
var main_1 = require("../../../reducers/slices/main");
var react_3 = require("react");
var validateForm_1 = require("../../../helpers/validateForm/validateForm");
var initialResetPasswordValues = { password: "", confirmPassword: "" };
var ResetPasswordPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_router_dom_1.useParams)(), isNewAccount = _a.isNewAccount, token = _a.token;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var isLoading = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).isLoading;
    var _b = (0, react_3.useState)(initialResetPasswordValues), credentials = _b[0], setCredentials = _b[1];
    var validationConfig = { password: { required: true }, confirmPassword: { isEqualTo: { key: "password", value: credentials.password } } };
    var _c = (0, validateForm_1.validateForm)(credentials, { validationConfig: validationConfig }), errors = _c.errors, isValid = _c.isValid;
    var showVerifiedBadge = isNewAccount === "1";
    var showLoader = function () {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "sm" }),
        }));
    };
    var handleResponse = function (response) {
        if (response.success) {
            setCredentials(initialResetPasswordValues);
            dispatch((0, main_1.setContentModal)({ title: "Success", content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
        }
        else
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
    };
    var _setCredentials = function (value) {
        setCredentials(__assign(__assign({}, credentials), value));
    };
    var _onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var password, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    password = credentials.password;
                    showLoader();
                    return [4 /*yield*/, (0, reset_password_1.reset_password)({
                            password: password,
                            token: token,
                        })];
                case 1:
                    response = _a.sent();
                    handleResponse(response);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-20", children: [showVerifiedBadge && ((0, jsx_runtime_1.jsx)("div", { className: "relative flex mb-4", children: (0, jsx_runtime_1.jsxs)(react_1.Badge, { children: [(0, jsx_runtime_1.jsx)(react_1.Badge.Anchor, { children: "Email Address Verified" }), (0, jsx_runtime_1.jsx)(react_1.Badge.Label, { children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:check-circle" }) })] }) })), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Reset your password", size: "3xlarge", textColor: "text-black", bold: true }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Create a new password for your account.", textColor: "text-black", size: "small" }), (0, jsx_runtime_1.jsxs)("div", { className: "w-full flex flex-col gap-y-4", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { type: "password", value: credentials.password, isInvalid: !!errors.password, onChange: function (value) {
                            _setCredentials({ password: value });
                        }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Enter New Password" }), (0, jsx_runtime_1.jsx)(react_1.Input, {}), errors.password ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: errors.password }) : null] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { type: "password", value: credentials.confirmPassword, isInvalid: !!errors.confirmPassword, onChange: function (value) {
                            _setCredentials({ confirmPassword: value });
                        }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Confirm New Password" }), (0, jsx_runtime_1.jsx)(react_1.Input, {}), errors.confirmPassword ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: errors.confirmPassword }) : null] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_1.Button, { isPending: isLoading, isDisabled: !isValid, variant: "primary", onPress: _onSubmit, children: "Submit" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-row justify-between items-center", children: (0, jsx_runtime_1.jsxs)(react_1.Button, { variant: "tertiary", size: "md", onPress: function () {
                        navigate("".concat(routes_1.WELCOME_ROUTE).concat(routes_1.LOG_IN_ROUTE));
                    }, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:chevron-left" }), "Back to sign in"] }) })] }));
};
exports.ResetPasswordPage = ResetPasswordPage;
